// Money helpers for the payment service: the BE stores integer cents, the FE
// shows dollars. Kept out of mappers.js, which only transforms API shapes.
const centsToDollars = (cents) => (Number(cents) || 0) / 100;

export const formatDollars = (cents) =>
  centsToDollars(cents).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

// Converts a dollar input ("$60.00", "60", 60) to integer cents for the API
// (create/patch use max_payout_amount_cents). Returns NaN for invalid input.
export const dollarsToCents = (value) => {
  const numeric = Number(String(value).replace(/[^0-9.]/g, ''));

  return Number.isNaN(numeric) ? NaN : Math.round(numeric * 100);
};
